var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreaterThan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04152 12.7464L12.2915 8.99635L6.04152 5.24635C5.95945 5.19711 5.88895 5.13379 5.83406 5.06003C5.77917 4.98626 5.74096 4.90349 5.72162 4.81644C5.70227 4.72938 5.70217 4.63975 5.72131 4.55266C5.74045 4.46557 5.77847 4.38272 5.83319 4.30885C5.94369 4.15967 6.11552 4.0561 6.31087 4.02094C6.4076 4.00353 6.50719 4.00344 6.60396 4.02066C6.70073 4.03789 6.79278 4.07211 6.87485 4.12135L13.9599 8.37235C14.074 8.44085 14.1676 8.53364 14.2323 8.64249C14.297 8.75134 14.3309 8.87289 14.3309 8.99635C14.3309 9.11981 14.297 9.24136 14.2323 9.35022C14.1676 9.45907 14.074 9.55186 13.9599 9.62035L6.87485 13.8714C6.79278 13.9206 6.70073 13.9548 6.60396 13.972C6.50719 13.9893 6.4076 13.9892 6.31087 13.9718C6.21415 13.9544 6.12218 13.92 6.04021 13.8706C5.95825 13.8212 5.88791 13.7577 5.83319 13.6839C5.77847 13.61 5.74045 13.5271 5.72131 13.44C5.70217 13.353 5.70227 13.2633 5.72162 13.1763C5.74096 13.0892 5.77917 13.0064 5.83406 12.9327C5.88895 12.8589 5.95945 12.7956 6.04152 12.7464Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreaterThan);
export default __webpack_public_path__ + "static/media/greater-than.4dba02ed49eb331ce03a818049129e20.svg";
export { ForwardRef as ReactComponent };